import { render } from "./processing-tv360-dialog.vue?vue&type=template&id=a463d072"
import script from "./processing-tv360-dialog.vue?vue&type=script&lang=js"
export * from "./processing-tv360-dialog.vue?vue&type=script&lang=js"

import "./processing-tv360-dialog.vue?vue&type=style&index=0&id=a463d072&lang=scss"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__